import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ProfilePictureMaker from '../../components/ProfilePictureMaker';

const ProfilePicPage: React.FC = () => (
  <ToolLayout
    title="Profile Picture Maker - Resize for Social Media | AllTools"
    description="Create profile pictures for Instagram, Twitter, LinkedIn, Facebook, YouTube. Crop, resize, and style. Free."
    canonicalPath="/profile-picture-maker"
  >
    <ProfilePictureMaker />
  </ToolLayout>
);

export default ProfilePicPage;
